module.exports = __webpack_public_path__ + "img/30.7864d37f.gif";